const dados = {
    nome: "Coisas Úteis",
    parceiro: "Digital While",
    ajuda_wpp: "https://api.whatsapp.com/send?phone=5527992044443&text=Ol%C3%A1%20vim%20do%20site!%0AGostaria%20de%20saber%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20produtos!",
    telefone: "2799204443",
    email: "digitalwhile@gmail.com",
    instagram: {
        link: "https://www.instagram.com/coisas_uteis_ofc/",
        nome: "coisas_uteis_ofc"
    },
    tiktok: {
        link: "https://www.tiktok.com/@coisas_uteis_ofc?is_from_webapp=1&sender_device=pc",
        nome: "coisas_uteis_ofc"
    },
    digital_while: {
        instagram: {
            nome: "digitalwhile.ofc",
            link: "https://www.instagram.com/digitalwhile.ofc/"
        },
        site: "https://digitalwhile.com.br"
    }
}

export default dados;